module.exports = __webpack_public_path__ + "img/icon_notification.78a7e547.svg";